import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { API_CONFIG, getAuthHeaders, buildApiUrl, APP_CONFIG } from '../config/api';
import { COLORS } from '../theme/tibiaTheme';

function Footer() {
  const [lastUpdate, setLastUpdate] = useState(null);
  const [apiVersion, setApiVersion] = useState(null);

  useEffect(() => {
    const fetchUpdateStatus = async () => {
      try {
        const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.UPDATE_STATUS), {
          headers: getAuthHeaders()
        });
        const data = await response.json();
        setLastUpdate(data.last_end_update);
      } catch (error) {
        console.error('Erro ao buscar status de atualização:', error);
      }
    };

    const fetchApiVersion = async () => {
      try {
        const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.ALIVE), {
          headers: getAuthHeaders()
        });
        const data = await response.json();
        setApiVersion(data.version);
      } catch (error) {
        console.error('Erro ao buscar versão da API:', error);
      }
    };

    // Busca inicial
    fetchUpdateStatus();
    fetchApiVersion();

    // Atualiza a cada 5 minutos (300000 ms)
    const interval = setInterval(fetchUpdateStatus, 300000);

    // Limpa o intervalo ao desmontar o componente
    return () => clearInterval(interval);
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: COLORS.surfaceContainer, // Mesma cor do AppBar e Drawer
        borderTop: `1px solid ${COLORS.outlineVariant}`, // outlineVariant
        textAlign: 'center',
        p: 1.5,
        boxShadow: '0px -1px 3px 1px rgba(0, 0, 0, 0.15), 0px -1px 2px 0px rgba(0, 0, 0, 0.3)', // elevation 1
        zIndex: 1000
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 0.5, position: 'relative' }}>
        <Typography variant="bodySmall" sx={{ 
          color: 'onSurface.main', // onSurface
          fontWeight: 500,
          letterSpacing: 0.25
        }}>
          © {new Date().getFullYear()} Maxwell | Versão Web: {APP_CONFIG.WEB_VERSION}{apiVersion && ` | API: ${apiVersion}`}
        </Typography>
        {lastUpdate && (
          <Typography variant="bodySmall" sx={{ 
            color: 'onSurfaceVariant.main', // onSurfaceVariant
            fontWeight: 500,
            letterSpacing: 0.4,
            position: 'absolute',
            right: 16
          }}>
            Última atualização: {formatDate(lastUpdate)}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default Footer;
